class PopupPanel extends HTMLElement {
  constructor() {
    super();

    this.hasButton = this.getAttribute('id') || false;
    if (this.hasButton) {
      document.querySelectorAll(`button[${this.hasButton}]`).forEach((element) => {
        element.addEventListener('click', (ev) => {
          this.show();
        });
      });
    }

    this.isOpen = false;
    this.locked = false;
    this.backdrop = this.parentNode.querySelector('.popup-panel-backdrop');
    this.autofocus = this.dataset.autofocus === 'true';

    this.bindEvents();
  }

  bindEvents() {
    this.querySelector('[close]').addEventListener('click', (ev) => {
      this.hide();
    });

    this.backdrop.addEventListener('click', (ev) => {
      this.hide();
    });

    this.addEventListener('custom:escape', (ev) => {
      this.hide();
    });

    this.addEventListener('transitionstart', (ev) => (this.locked = true));
    this.addEventListener('transitionend', (ev) => (this.locked = false));
  }

  show() {
    if (this.locked) return;
    this.classList.remove('hidden');
    this.backdrop.classList.remove('hidden');

    requestAnimationFrame(() => {
      this.classList.add('-translate-y-1/2');
      this.classList.remove('opacity-0');
      if (document.documentElement.getBoundingClientRect().height > window.innerHeight) {
        document.documentElement.classList.add('overflow-hidden');
      }
    });

    waitForTransitionEnd(this).then(() => {
      trapFocus(this);
      this.isOpen = true;
    });
  }

  hide() {
    if (this.locked) return;
    this.classList.add('opacity-0');
    this.classList.remove('-translate-y-1/2');
    this.backdrop.classList.add('hidden');

    releaseFocus(this);
    this.isOpen = false;

    waitForTransitionEnd(this).then(() => {
      document.documentElement.classList.remove('overflow-hidden');
      this.classList.add('hidden');
    });
  }
}

customElements.define('popup-panel', PopupPanel);
